module.exports = __webpack_public_path__ + "static/media/user-nurse.bb8b1081.svg";